import ko from "knockout";
import $ from "jquery";

// See the style guide for implementation details
const LOADER_MARKUP =
    '<div class="load-indicator load-indicator-flex load-indicator-sm"><i class="pc-icon-comet fa fa-spin"></i></div>';
const LIGHT_LOADER_MARKUP =
    '<div class="load-indicator load-indicator-flex load-indicator-sm load-indicator-inverse"><i class="pc-icon-comet fa fa-inverse fa-spin"></i></div>';

const parseOptions = function (templateData) {
    const options = { isLoading: false, light: false };
    if (
        typeof templateData == "boolean" ||
        templateData === null ||
        templateData === undefined
    ) {
        options.isLoading = !!templateData; // use !! to ensure it's a boolean value
    } else {
        $.extend(options, {
            isLoading: ko.unwrap(templateData.isLoading),
            disable: ko.unwrap(templateData.disable),
            light: ko.unwrap(templateData.light),
        });
    }

    return options;
};

const setLoadingState = function ($element, options) {
    $element.toggleClass("is-working", options.isLoading);
};

/**
 * <p>Binding handler for buttons that show a spinner while working.</p>
 * <p>
 *   Examples:<br/>
 *   <pre class="prettyprint">
 * &lt;button data-bind="waitButton: isFormLoading"&gt;
 *     Shows spinner, and is disabled when isFormLoading is true
 * &lt;/button&gt;
 *
 * &lt;button data-bind="waitButton: {isLoading: isFormLoading, disable: false}"&gt;
 *     Shows spinner, but doesn't change disabled state
 * &lt;/button&gt;
 *
 * &lt;button data-bind="waitButton: {isLoading: isFormLoading, light: true}"&gt;
 *     Shows the light version of the spinner
 * &lt;/button&gt;
 *   </pre>
 * </p>
 * <p>
 *   The optional disable option (defaults to true) determines whether or not the
 *   waitButton binding tries to control the button's disabled state. It's useful to
 *   turn it off and use the built-in disable/enable bindings when there are multiple
 *   conditions that can cause the button to become disabled.
 * </p>
 *
 * @exports bindingHandlers/externalTemplate
 */
ko.bindingHandlers.waitButton = {
    init: function (element, valueAccessor) {
        const options = parseOptions(ko.unwrap(valueAccessor()));
        const $element = $(element);
        $element.append(options.light ? LIGHT_LOADER_MARKUP : LOADER_MARKUP);
    },
    update: function (element, valueAccessor) {
        const options = parseOptions(ko.unwrap(valueAccessor()));
        setLoadingState($(element), options);
    },
};
